import { render, staticRenderFns } from "./ImageFeature.vue?vue&type=template&id=08aa9508&scoped=true&"
import script from "./ImageFeature.vue?vue&type=script&lang=js&"
export * from "./ImageFeature.vue?vue&type=script&lang=js&"
import style0 from "./ImageFeature.vue?vue&type=style&index=0&id=08aa9508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa9508",
  null
  
)

export default component.exports